/**
 * Persists whether a visitor has seen the `/welcome` landing page.
 *
 * First-ever visit to `/` redirects to `/welcome`; once the visitor
 * clicks any CTA there (or "skip"), the flag flips and future visits
 * land directly in the app.
 */
const WELCOME_DISMISSED_KEY = "welcomeModalDismissed";

export function hasSeenWelcome(): boolean {
  try {
    return localStorage.getItem(WELCOME_DISMISSED_KEY) === "true";
  } catch {
    return true; // private mode / blocked storage — don't loop
  }
}

export function dismissWelcome(): void {
  try {
    localStorage.setItem(WELCOME_DISMISSED_KEY, "true");
  } catch {
    // ignore
  }
}
